module.exports = __webpack_public_path__ + "img/1_nyc.24c83ca0.jpg";